import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import locale from "element-plus/lib/locale/lang/zh-cn";
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts'

import 'element-plus/dist/index.css'
import './style/element.scss'

import './assets/css/all.css'
import './assets/icon/iconfont.css'
import '@/permission'


import eventBus from '@/utils/bus.js'/// mitt 总线程引入
//拖动排序
// import VueDND from 'awe-dnd'
// Vue.use(VueDND)

import component from '@/utils/component';//注册全局组件
// import fun from '@/utils/fun';//注册全局组件

const app = createApp(App)
app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$bus = eventBus//挂载全局属性
import { copy, message, fplx, checkStrInArray, subjectFilterCode, findCode, buttonStatus, checkSettleStatus , inventoryTypeFilter , inventoryCategoryFilter , VoucherSourceFilter ,tableNameFilter, taxPayerTypeFilter ,setUpStatusSb ,setUpStatusGsSb ,setUpStatusKk,setUpStatusJc,setUpStatusCj,setUpStatusQY ,setUpStatusImport,setUpStatusMatch } from '@/utils/fun'
import { parseTime, getHeight ,goEtax, getLastDay } from '@/utils/index'
import { newformatDate } from '@/utils/timeConversion'
app.mixin({
  methods: {
    $qzfMessage: message,
    $qzfCopy: copy,
    $fplx: fplx,
    $checkStrInArray: checkStrInArray,//检测数组中是否存在
    $subjectFilterCode: subjectFilterCode,//获取科目
    $findCode: findCode,//获取基础科目
    $buttonStatus: buttonStatus,//按钮权限
    $checkSettleStatus: checkSettleStatus,//结账
    $parseTime: parseTime,//格式化时间 parseTime(v.checkDate, "{y}-{m}-{d}")
    $inventoryTypeFilter:inventoryTypeFilter, //存货类别
    $inventoryCategoryFilter:inventoryCategoryFilter, //存货类型
    $VoucherSourceFilter:VoucherSourceFilter, //凭证来源
    $tableNameFilter:tableNameFilter, // 税务报表名称
    $taxPayerTypeFilter:taxPayerTypeFilter, //纳税人类型
    $getHeight: getHeight,
    $goEtax:goEtax,
    $setUpStatusSb:setUpStatusSb,
    $setUpStatusKk:setUpStatusKk,
    $setUpStatusJc:setUpStatusJc,
    $setUpStatusCj:setUpStatusCj,
    $setUpStatusQY:setUpStatusQY,
    $setUpStatusGsSb:setUpStatusGsSb,
    $setUpStatusImport:setUpStatusImport,
    $setUpStatusMatch:setUpStatusMatch,
    $getLastDay: getLastDay,//获取账期最后一天
    $newformatDate:newformatDate
  }
})

String.prototype.moneyFilter = function(){
  if(this.indexOf('(') > -1){
    let amount = this.replace("(", "").replace(")","")
    return Number((-amount.replace(/,/g, "").replace("¥", "").replace("å", "").replace("元", "").replace("￥", "")  * 1).toFixed(2))
  }else{
    return Number((this.replace(/,/g, "").replace("¥", "").replace("å", "").replace("元", "").replace("￥", "")  * 1).toFixed(2))
  }
}

/**
 * 检测图片是否存在
 * @param url
 */
 let imageIsExist = function(url) {
  return new Promise((resolve) => {
      var img = new Image();
      img.onload = function () {
          if (this.complete == true){
              resolve(true);
              img = null;
          }
      }
      img.onerror = function () {
          resolve(false);
          img = null;
      }
      img.src = url;
  })
}
app.directive('err-img', async function (el, binding) {//指令名称为：real-img
  let imgURL = binding.value;//获取图片地址
  if (imgURL) {
      let exist = await imageIsExist(imgURL);
      if (exist) {
        el.setAttribute('src', imgURL);
      } 
  }
})

//挂载自定指令
import autoFocus from '@/utils/auto-focus'
app.directive('auto-focus', autoFocus)

//挂载naive-ui
import naive from 'naive-ui'
app.use(naive)

app.use(component).use(ElementPlus,{locale}).use(store).use(router).mount('#app')